import React from 'react'
import ListComp from '../../../components/ListComp'
import { CiEdit } from 'react-icons/ci'
import { usePosterReducers } from '../../../../../redux/getdata/usePostReducer';
import { dateFormat } from '../../../../utils/common';
import { AiOutlineDelete } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import { page_lists } from '../../../../api/websocket/payload';
import Notfound from '../../../components/Notfound';
interface IList {
  toggleWarn: Function;
}
const List: React.FunctionComponent<IList> = (props)=> {
  const { blogs_list } = usePosterReducers()
  const navigate = useNavigate()
  return (
    // 'Active',
    <ListComp payLoad={page_lists} pages={blogs_list?.pagination}  header={['Blog Image','Blog Title','Created At','Actions']}>
      {blogs_list?.data?.length > 0 ?
          blogs_list?.data?.map((item, index) => (
              <tr key={index}  className="border-b  text-sm rounded-md  ">
                <td className="p-3  flex justify-center">
              <img className="h-20 w-24"  src={item?.images[0]}  alt="" />
            </td>
                <td>{item?.title}</td>
                <td>{dateFormat(item?.created_at)}</td>
                <td>
                  <div className="flex justify-start items-center gap-2">
                    <button
                      onClick={() => navigate(`/content-management/blog/update-blog/${item?.id}`)}
                      className="p-2 text-base text-black rounded-md"
                    >
                      <CiEdit />
                    </button>
                    <button
                      onClick={() => props.toggleWarn("",item?.id,'delete')}
                      className="p-2  text-base text-black rounded-md"
                    >
                      <AiOutlineDelete />
                    </button>
                  </div>
                </td>
              </tr>
            
          )):
          <Notfound msg="Blogs are Not Found!"/>
          }
    </ListComp >
  )
}

export default List